import { cn } from '@/utils/styles';
import { ListItemIcon } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';

export default function MenuOptions({
    options = [],
    customChildren = null,
    title = '',
    onSelect,
    initialSelectedIndex = 0,
    classNameButton = '',
    classNameContainer = '',
    ...props
}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClickListItem = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (event, index) => {
        setAnchorEl(null);
        if (onSelect) {
            onSelect(options[index], index);
        }
        if (options[index].onClick) {
            options[index].onClick();
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className={cn('w-full', classNameContainer)} >
            <div
                id="custom-list-button"
                aria-haspopup="listbox"
                aria-controls="custom-menu"
                aria-label="menu options"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClickListItem}
                className={`flex items-center gap-2 w-full ${classNameButton}`}
            >
                {title}
            </div>
            {open &&
                <Menu
                    id="custom-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'custom-list-button',
                        role: 'listbox',
                    }}
                    PopoverClasses={{
                        paper: 'rounded-2xl',
                        backgroundColor: (theme) => theme.mode == 'dark' ? 'red' : 'white'
                    }}
                    {...props}
                >
                    {customChildren ? (
                        <>
                            {typeof customChildren === 'function'
                                ? customChildren(handleClose)
                                : customChildren}
                        </>) :
                        (<>
                            {options.map((option, index) => (
                                <MenuItem
                                    key={option.label || index}
                                    disabled={option.disabled}
                                    onClick={(event) => handleMenuItemClick(event, index)}
                                    className='text-night-black dark:text-white'
                                >
                                    {option.icon && (
                                        <ListItemIcon>
                                            {option.icon}
                                        </ListItemIcon>
                                    )}
                                    {option.label}
                                </MenuItem>
                            ))}
                        </>
                        )}
                </Menu>}
        </div>
    );
}